<template>
	<AppScreen class="game-view" :scrollable="false">
		<div class="content">
			<Sidebar class="sidebar" />
			<GameSpace ref="gameSpace" class="game-space" />
			<Bunny
				ref="bunny"
				class="hint"
				v-if="hintReady"
				:content="hint.content"
				:buttons="[{ text: hint.close_button_text, action: closeHint }]"
				:position="hint.position"
			/>
		</div>
	</AppScreen>
</template>

<script>
import { mapGetters } from "vuex";
import AppScreen from '@/components/partials/AppScreen';
import Sidebar from '@/components/views/game/Sidebar';
import GameSpace from '@/components/views/game/GameSpace';
import Bunny from '@/components/partials/Bunny';
import { ROOT } from "@/store/mutations";

const { ROUTE_CHANGED } = ROOT;

export default {
	name: 'Game',
	components: {
		AppScreen,
		Bunny,
		Sidebar,
		GameSpace,
	},
	data() {
		return {
			keepHintActive: false,
			unsubscriber: () => {},
		};
	},
	computed: {
		...mapGetters({
			hint: "game/hints/active",
		}),
		hintReady() {
			return this.hint && (!this.$refs.gameSpace?.isTransitioning || this.keepHintActive);
		},
	},
	methods: {
		closeHint() {
			if (this.$refs.bunny) {
				this.$refs.bunny.pushState("exiting", this.cleanUpHint);
			} else {
				this.cleanUpHint();
			}
		},
		cleanUpHint() {
			this.$store.dispatch(`game/hints/${this.hint.id}/complete`);
			this.keepHintActive = false;
			this.unsubscriber();
			this.unsubscriber = () => {};
		},
	},
	watch: {
		hint(current, previous) {
			if (current && current.id !== previous?.id) {
				this.unsubscriber = this.$store.subscribe((mutation) => {
					if (mutation.type === ROUTE_CHANGED) {
						this.keepHintActive = true;
						this.closeHint();
					}
				});
				// this.$store.dispatch(`game/hints/${this.hint.id}/listenForRouteChange`);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	.game-view {
		width: 100%;
		height: 100%;

		@include desktop {
			min-height: $min-desktop-height;
		}
	}

	.content {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: 100%;
	}

	.sidebar {
		position: relative;
		z-index: $z-bottom-mid;
	}

	.game-space {
		position: relative;
		z-index: $z-bottom;
	}

</style>



// WEBPACK FOOTER //
// src/components/views/Game.vue